export type SupportAgentPermissions = {
  canViewAccounts: boolean;
  canViewClaims: boolean;
  canViewCommissionsAnd1099s: boolean;
  canViewCorrespondence: boolean;
  canViewPendingUnderwritingRequirements: boolean;
  canViewPolicies: boolean;
  canViewPolicyServiceRequest: boolean;
};

export const DefaultSupportAgentPermissions: SupportAgentPermissions = {
  canViewAccounts: false,
  canViewClaims: false,
  canViewCommissionsAnd1099s: false,
  canViewCorrespondence: false,
  canViewPendingUnderwritingRequirements: false,
  canViewPolicies: false,
  canViewPolicyServiceRequest: false,
};
